module.exports = __webpack_public_path__ + "static/img/s5.9d43695.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/s5.png
// module id = Vi9X
// module chunks = 0